import { useState } from 'react';

import { Avatar, IconButton, Popover, Stack, Typography } from '@mui/material';

import { selectCurrentUser } from '@src/store/auth/auth-selectors';
import { useAppSelector } from '@src/store/store';

import useLocales from '@src/locales/use-locales';

const AccountInfo = () => {
  const { t } = useLocales();
  const user = useAppSelector(selectCurrentUser);

  const { firstName, lastName, role } = user!;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const subTitle =
    role === 'ADMIN' ? t('account.administrator') : t('account.user');

  const avatarLetter = firstName?.at(0)?.toUpperCase();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'user info popover' : undefined;

  return (
    <Stack
      gap={2}
      sx={{
        p: 0.5,
        backgroundColor: 'custom.background',
        borderRadius: 1,
        alignItems: 'center',
      }}
    >
      <IconButton onClick={handleClick}>
        <Avatar
          aria-describedby={id}
          sx={{ backgroundColor: 'primary.dark', color: 'common.white' }}
        >
          <Typography
            sx={{
              fontFamily: 'secondaryFontFamily',
              fontSize: '12px',
              fontWeight: 'fontWeightSemiBold',
              color: 'common.white',
            }}
          >
            {avatarLetter}
          </Typography>
        </Avatar>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              width: 100,
              p: 1,
            },
          },
        }}
      >
        <Stack gap={0.5} sx={{ alignItems: 'center' }}>
          <Typography variant="button">{`${firstName} ${lastName}`}</Typography>
          <Typography
            sx={{
              fontFamily: 'fontFamily',
              fontSize: '12px',
              letterSpacing: 0.15,
              color: 'custom.grey',
            }}
          >
            {subTitle}
          </Typography>
        </Stack>
      </Popover>
    </Stack>
  );
};

export default AccountInfo;
